module.exports = __webpack_public_path__ + "mobile-travel-header-img.00fe1269.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Travel/mobile-travel-header-img.jpg
// module id = 620
// module chunks = 0